import React from 'react';
import {useStyles} from './helper';

const InformationBlock = ({children, label, width, lineColor, height}) => {
    const classes = useStyles();
    return (
        <div 
            className={classes.root} 
            style={{width, height: height ? height : '100%'}}
        >
            <div 
                style={{borderLeft: `2px solid ${lineColor}`}} 
                className={classes.wrap}
            >
                <span 
                    className={classes.label}
                >
                    {label}
                </span>
                <div 
                    className={classes.children}
                >
                </div>
                {children}
            </div>
        </div>
    )
}

export default InformationBlock;